import React, { useEffect, useState } from "react";
import styles from "./sidebar.module.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link ,withRouter} from "react-router-dom";


const Sidebar = (props) => {
  const [select, setSelect] = useState(0);
  const params=props.location?.pathname;
  console.log(params)
  useEffect(()=>{
    if(params==='/reports'){
      setSelect(0)
    }
    else if(params==='/reports/department-curr'){
      setSelect(1)
    }
    else if(params==='/reports/mapping-report'){
      setSelect(2)
    }
    else if(params==='/reports/program-level'){
      setSelect(4)
    }
    else if(params==='/reports/transpose-prog'){
      setSelect(5)
    }
  },[params])

  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={select}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{ style: { background: "transparent" } }}
      >
        <Tab
          component={Link}
          to="/reports"
          label="Faculty Profile"
          style={{ minWidth: "100%" }}
          className={select == 0 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(0)}
        />
        <Tab
          component={Link}
          to="/reports/department-curr"
          label="Department / Curriculum Report "
          style={{ minWidth: "100%" }}
          className={select == 1 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(1)}
        />
        <Tab
          component={Link}
          to="/reports/mapping-report"
          label="Mapping Report"
          style={{ minWidth: "100%" }}
          className={select == 2 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(2)}
        />
        {/*<Tab
         component={Link}
         to="/reports/program-art"
         label="Program Articulation Matrix Report ( Term-wise )"
         style={{ minWidth: "100%" }}
         className={select == 3 ? styles.activeTab : undefined}
         onClick={(e) => setSelect(3)}
         />*/} 
        <Tab
          component={Link}
          to="/reports/program-level"
          label="Program Level Course - PO Matrix"
          style={{ minWidth: "100%" }}
          className={select == 4 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(4)}
        />
        <Tab
          component={Link}
          to="/reports/transpose-prog"
          label="Transpose of Program Articulation Matrix"
          style={{ minWidth: "100%" }}
          className={select == 5 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(5)}
        />
        {/* <Tab
          component={Link}
          to="/reports/course-domain-report"
          label="Course Domain ( Vertical ) Report"
          style={{ minWidth: "100%" }}
          className={select == 6 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(6)}
        />
        <Tab
          component={Link}
          to="/reports/termwise-course"
          label="Term-wise Course Report"
          style={{ minWidth: "100%" }}
          className={select == 7 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(7)}
        />
        <Tab
          component={Link}
          to="/reports/theory-lesson"
          label="Theory Lesson Plan ( Course-wise ) Report"
          style={{ minWidth: "100%" }}
          className={select == 8 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(8)}
        />
        <Tab
          component={Link}
          to="/reports/lab-lesson"
          label="Lab Lesson Plan ( Course-wise ) Report"
          style={{ minWidth: "100%" }}
          className={select == 9 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(9)}
        />
        <Tab
          component={Link}
          to="/reports/text-ref"
          label="Text / Reference Book List"
          style={{ minWidth: "100%" }}
          className={select == 10 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(10)}
        />
        <Tab
          component={Link}
          to="/reports/cia-question"
          label="CIA, TEE Question Paper Report Course-wise"
          style={{ minWidth: "100%" }}
          className={select == 11 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(11)}
        />
        <Tab
          component={Link}
          to="/reports/ao-mapping"
          label="AO to CO Mapping Report Course-wise"
          style={{ minWidth: "100%" }}
          className={select == 12 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(12)}
        />
        <Tab
          component={Link}
          to="/reports/unmapped-report"
          label="Unmapped PO Report"
          style={{ minWidth: "100%" }}
          className={select == 13 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(13)}
        />
        <Tab
          component={Link}
          to="/reports/student-imp"
          label="Student Improvement Plan Report"
          style={{ minWidth: "100%" }}
          className={select == 14 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(14)}
        /> */}
      </Tabs>
    </>
  );
};

export default withRouter(Sidebar);
